import { render, staticRenderFns } from "./OBtnWhatsappComp.vue?vue&type=template&id=be8e4a7c&"
import script from "./OBtnWhatsappComp.vue?vue&type=script&lang=js&"
export * from "./OBtnWhatsappComp.vue?vue&type=script&lang=js&"
import style0 from "./OBtnWhatsappComp.vue?vue&type=style&index=0&id=be8e4a7c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports